import React, { FC, useEffect, useState, useMemo } from "react";
import {
  Button,
  Icon,
  Box,
  Grid,
  Dialog,
  DialogContent,
  DialogActions,
  useMediaQuery,
} from "@mui/material";

import "./style.css";
import adminStore from "src/store/AdminStore";
import FileSaver from "file-saver";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { StringUtil } from "src/framework/commons/StringUtil";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { useObservable } from "src/framework/store/storeUtil";
import { atributos$, CacheType, resolveProtocolUrl } from "src/store/global.store";
import theme from "src/theme/light";
import { IAtributosDom } from "../types";
import { LoginStore } from "src/framework/store/LoginStore";
import { getAtributos } from "src/components/projetos/edicao/layouts/EdicaoLayout";

export interface ModalDetalhesModel {
    open: boolean;
    setOpenModal: Function;
    componentId?: number;
}

interface Documento {
    nome: string;
    url: string;
    tipo: string;
}

const TIPOS_DOCUMENTOS_PERMITIDOS = [
    { tipo: "datasheet",  label: "DATASHEET",ordem: 1 },
    { tipo: "procel", label: "SELO PROCEL", ordem: 2 },
    { tipo: "fabricante", label: "DECLARAÇÃO DO FABRICANTE", ordem: 3 },
    { tipo: "inmetro", label: "SELO INMETRO", ordem: 4 },
    { tipo: "manual", label: "MANUAL DE INSTALAÇÃO", ordem: 5 },
    { tipo: "simulacao", label: "ARQUIVO DE SIMULAÇÃO", ordem: 6 }
]

const ModalDetalhes: FC<ModalDetalhesModel> = (modalDetalhesModel) => {
const permissoes:string[] = useObservable(LoginStore.permissoes) || [];

const [componenteState, setComponente] = useState<any>();
const [imageEstate, setImageEstate] = useState<any>();
const [documentos, setDocumentos] = useState<Documento[]>([])
const [categoriaEstate, setCategoria] = useState<any>();
const _upload = LocalStorage.get("solar.uploadInfo", true);
const cachedAtributos = useObservable<CacheType<IAtributosDom[]>>(atributos$)
const atributosState = useMemo(()=>{
    return cachedAtributos?.data || []
  },[cachedAtributos])
const atributos = useMemo(() => componenteState?.atributos, [componenteState]);

const isMobile = useMediaQuery(theme.breakpoints.down('md'));

let componente_id = modalDetalhesModel?.componentId;

const downloadDocumento = (url: string, tipo: string, nomeArquivo: string): void => {
    if (url !== "") {
            let _nomeArquivo = nomeArquivo;
            _nomeArquivo = StringUtil.clear(_nomeArquivo);
            _nomeArquivo = _nomeArquivo.replace(/[^a-zA-Z0-9-\u00C0-\u00FF\s]/g, "");
            const name: string[] = url.split(".");
            const extension: string | undefined = name.pop()?.replace(/\?r\=\d{1,}/, "");
            if (extension) {
            FileSaver.saveAs(url, `${tipo}-${_nomeArquivo}.${extension}`)
        }
    }
};

const getTitulo = (atributo: string) => {
    let objAtributo = atributosState?.find((a: { id: any; }) => a?.id === atributo)
    let descricao = objAtributo?.titulo
    if (objAtributo?.sufixo){
        descricao = `${objAtributo?.titulo} (${objAtributo?.sufixo})`
    }
    return descricao;
}

const temPermissaoCodigoComponente = useMemo(()=>{
    return PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE, permissoes)
},[permissoes])

const formatValue = (value: any, kind?: string) => {
    if (value) {
        const list = String(value)?.split(',') || [];
        const atributo = atributosState?.find((a: { id: any; }) => a?.id === kind);
        const enums = atributo?.valores?.enum;
        if (enums && list?.length) {
            return list?.map((i: any) => enums?.find((item: any) => Number(item?.value) === Number(i))?.text || '')?.join(', ');
        } else if (kind === 'PERFIL_VENDIDO_PARES') {
            return value === "true" ? 'Sim' : 'Não';
        }
    }
    return !isNaN(Number(value)) ? String(Number(value).toFixed(2))?.replaceAll('.', ',') : value;
};

const formatTempoGarantia = (unidade: string): string => {
    switch (unidade) {
        case 'meses':
            return 'mes(es)';
        case 'anos':
            return 'ano(s)';
        default:
            return unidade;
    }
};

var atributosDinamicos = Object.keys(componenteState?.atributos || {})?.map(function(key) {
    return  (
        <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
            <Box className="subtitulo">{getTitulo(key)}: </Box><Box component="span">{formatValue(componenteState?.atributos[key], key) || '--'}</Box>
        </Grid>
    )
});

useEffect(() => {
    const getData = async () => {
        if (componente_id) {
            setImageEstate(null); 
            setComponente(null); 
            setDocumentos([])
    
            if (!atributosState.length) {
                await getAtributos();
            }
    
            adminStore.getComponente(componente_id, true).then((resp) => {
                setComponente(resp[0]);
    
                const uploads = resp?.[0]?.uploads || [];
    
                if (uploads.length && uploads.some((u: any) => TIPOS_DOCUMENTOS_PERMITIDOS.map(item => item.tipo).includes(u?.tipo))) {
                    const documentosFiltrados = uploads.filter((u: any) => TIPOS_DOCUMENTOS_PERMITIDOS.map(item => item.tipo).includes(u?.tipo));
                    setDocumentos(documentosFiltrados.map((item: any): Documento => ({
                        url: item.url,
                        tipo: item.tipo,
                        nome: TIPOS_DOCUMENTOS_PERMITIDOS.find(t => t.tipo === item.tipo)?.label || item.tipo
                    })).sort((a: any, b: any) => {
                        const tipoA = TIPOS_DOCUMENTOS_PERMITIDOS.find(t => t.tipo === a.tipo);
                        const tipoB = TIPOS_DOCUMENTOS_PERMITIDOS.find(t => t.tipo === b.tipo);
                        return (tipoA?.ordem || 1) - (tipoB?.ordem || 1);
                    }));
                }
                const upload = uploads?.filter((u: any) => u?.tipo === 'image');
                if(upload){
                    setImageEstate(upload[0]);
                } else {
                    setImageEstate(null);
                }
                if (resp[0]?.categoria_componentes_id){
                    adminStore.getCategoria(resp[0].categoria_componentes_id, true).then((resp) => {
                        setCategoria(resp[0]);
                    })
                }
            })
            modalDetalhesModel.setOpenModal(true);
        }
    }

    getData();
}, [componente_id, modalDetalhesModel]);

  const handleClose = () => {
    setImageEstate(null); 
    setComponente(null); 
    setDocumentos([])
    modalDetalhesModel.setOpenModal(false);
  };

  return (
    <>
        <div>
            {!!componenteState && (!!componenteState.categoria_componentes_id && !!categoriaEstate) && 
                <Dialog className="dialog_detalhes"
                    open={modalDetalhesModel.open}
                    onClose={handleClose}
                    maxWidth='md'
                >
                    <DialogContent color="secundary">
                        <Grid container spacing={3}>
                            <Grid size={{ xs: 12, md: 2 }} style={isMobile ? { textAlign: 'center', marginTop: 15 } : {}}>
                                {
                                    imageEstate && (
                                        <img 
                                            alt='Componente' 
                                            src={resolveProtocolUrl(`//${_upload?.data?.url}${imageEstate.url}`)} 
                                            style={isMobile ? { width: "100%", maxWidth: "180px" } : { width: "145px" }} 
                                        />
                                    )
                                }
                            </Grid>
                            <Grid container size={{ xs: 12, md: 10 }}>
                                <Box width={"100%"} >
                                    <Box component={isMobile ? "h2" : "h1"} className="titulo">{temPermissaoCodigoComponente ? `${componenteState?.id} - ` : ''} {componenteState?.nome}</Box>
                                    <Box component="span"><Box component="span" className="subtitulo"> Produto: </Box> {componenteState?.descricao}</Box>
                                    <Box component="p">{componenteState?.descricao_componente}</Box>
                                    <Grid container>
                                        {!!documentos.length && documentos.map(doc => (
                                            <Grid size={{ xs: 12, md: 4 }} style={ isMobile ? { marginBottom: 8 } : {}}>
                                                <Button
                                                    fullWidth={isMobile}
                                                    variant={isMobile ? "outlined" : "text"}
                                                    size={isMobile ? "medium" : "small"}
                                                    onClick={() => {
                                                        downloadDocumento(resolveProtocolUrl(`//${_upload?.data?.url}${doc.url}`), doc.tipo, String(componenteState?.modelo));
                                                    }}
                                                    color={'primary'}
                                                >
                                                    <Box display={"flex"}>
                                                        <Icon style={{ marginRight: "2px" }} color={"primary"}>download</Icon>
                                                        <span>{doc.nome}</span>
                                                    </Box>
                                                </Button>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>
                                <Grid size={12}>
                                    <Box component="h3"> Detalhes do Componente:</Box>
                                </Grid>
                                { categoriaEstate?.grupo !== 'modulos' && (
                                    <>
                                        <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                            <Box className="subtitulo">Altura (m): </Box><Box component="span">{formatValue((componenteState?.altura || 0) / 1000) || '--'}</Box>
                                        </Grid>
                                        <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">Comprimento (m): </Box><Box component="span">{formatValue((componenteState?.comprimento || 0) / 1000) || '--'}</Box>
                                        </Grid>
                                    </>
                                )}
                                <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                    <Box className="subtitulo">Tempo de garantia: </Box><Box component="span">{componenteState?.tempo_garantia} {formatTempoGarantia(componenteState?.tempo_garantia_unidade || '')}</Box>
                                </Grid>
                                { categoriaEstate?.grupo !== 'modulos' && (
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">Largura (m): </Box><Box component="span">{formatValue((componenteState?.largura || 0) / 1000) || '--'}</Box>
                                    </Grid>
                                )}
                                <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                    <Box className="subtitulo">Peso (Kg): </Box><Box component= "span">{formatValue(componenteState?.peso) || '--'}</Box>
                                </Grid>
                                <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                    <Box className="subtitulo">Considerar para cálculo: </Box><Box component="span">{componenteState?.considerar_calculo ? "Sim" : "Não"}</Box>
                                </Grid>

                                {categoriaEstate?.grupo === 'modulos' && atributos &&
                                    <><Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo"> {getTitulo('MODULO_POTENCIA')}: </Box><Box component="span">{formatValue(atributos['MODULO_POTENCIA']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('MODULO_PERDA_PRIMEIRO_ANO')}: </Box><Box component='span'>{formatValue(atributos['MODULO_PERDA_PRIMEIRO_ANO']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('MODULO_PERDA_ANOS_SEGUINTES')}: </Box><Box component='span'>{formatValue(atributos['MODULO_PERDA_ANOS_SEGUINTES']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('MODULO_LARGURA_CALCULO')}: </Box><Box component='span'>{formatValue(atributos['MODULO_LARGURA_CALCULO']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('MODULO_ALTURA_CALCULO')}: </Box><Box component='span'>{formatValue(atributos['MODULO_ALTURA_CALCULO']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('LARGURA_MODULO')}: </Box><Box component='span'>{formatValue(atributos['LARGURA_MODULO']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('MODULO_TENSAO_VOC')}: </Box><Box component='span'>{formatValue(atributos['MODULO_TENSAO_VOC']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('MODULO_CORRENTE_MAXIMA_STC')}: </Box><Box component='span'>{formatValue(atributos['MODULO_CORRENTE_MAXIMA_STC']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('MODULO_TENSAO_VMP')}: </Box><Box component='span'>{formatValue(atributos['MODULO_TENSAO_VMP']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('MODULO_POTENCIA_MINIMA')}: </Box><Box component='span'>{formatValue(atributos['MODULO_POTENCIA_MINIMA']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('MODULO_POTENCIA_MAXIMA')}: </Box><Box component='span'>{formatValue(atributos['MODULO_POTENCIA_MAXIMA']) || '--'}</Box>
                                    </Grid>
                                    </>
                                }

                                {categoriaEstate?.grupo === 'inversores' && atributos &&
                                    <><Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_TENSAO_MAXIMA_ENTRADA')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_TENSAO_MAXIMA_ENTRADA']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_POTENCIA_MAXIMA_ENTRADA')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_POTENCIA_MAXIMA_ENTRADA']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_NUMERO_CONECTORES')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_NUMERO_CONECTORES']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_MENOR_NIVEL_TENSAO_MPPT')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_MENOR_NIVEL_TENSAO_MPPT']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_MAIOR_NIVEL_TENSAO_MPPT')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_MAIOR_NIVEL_TENSAO_MPPT']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_TENSAO_INICIALIZACAO')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_TENSAO_INICIALIZACAO']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_TENSAO')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_TENSAO'], 'INVERSOR_TENSAO') || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_TIPO_CONEXAO')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_TIPO_CONEXAO'], 'INVERSOR_TIPO_CONEXAO') || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">Quantidade MPPT: </Box><Box component='span'>{formatValue(componenteState?.mppt?.length) || '--'}</Box>
                                    </Grid>
                                    </>
                                }
                                
                                {/* Microinversores */}
                                {categoriaEstate?.grupo === 'inversores' && categoriaEstate?.id === 30 && atributos &&
                                    <>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_TENSAO_MAXIMA_ENTRADA')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_TENSAO_MAXIMA_ENTRADA']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_POTENCIA_MAXIMA_ENTRADA')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_POTENCIA_MAXIMA_ENTRADA']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_NUMERO_CONECTORES')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_NUMERO_CONECTORES']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_MENOR_NIVEL_TENSAO_MPPT')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_MENOR_NIVEL_TENSAO_MPPT']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_MAIOR_NIVEL_TENSAO_MPPT')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_MAIOR_NIVEL_TENSAO_MPPT']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_MAXIMO_SERIE')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_MAXIMO_SERIE']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_QUANTIDADE_GRAMPOS')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_QUANTIDADE_GRAMPOS']) || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_TENSAO')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_TENSAO'], 'INVERSOR_TENSAO') || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">{getTitulo('INVERSOR_TIPO_CONEXAO')}: </Box><Box component='span'>{formatValue(atributos['INVERSOR_TIPO_CONEXAO'], 'INVERSOR_TIPO_CONEXAO') || '--'}</Box>
                                    </Grid>
                                    <Grid className='grid-detalhes' size={{ xs: 12, md: 4 }} style={isMobile ? {paddingLeft: 0, paddingTop: 0} : {}}>
                                        <Box className="subtitulo">Quantidade MPPT: </Box><Box component='span'>{formatValue(componenteState?.mppt?.length) || '--'}</Box>
                                    </Grid>
                                    </>
                                }
                                {categoriaEstate?.grupo !== 'inversores' && categoriaEstate?.grupo !== 'modulos' && atributos &&
                                    atributosDinamicos
                                }
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button className='btn-modal' onClick={handleClose} fullWidth={isMobile}>
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </div>
    </>
  );
};

export { ModalDetalhes };
